// extracted by mini-css-extract-plugin
export default {"productGrid":"WZ-z","centerLink":"XZ-z","productSection":"YZ-z","item":"ZZ-z","ctaButton":"_Z-z"};